import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { ContatoTipoApiService } from "./contato-tipos/shared/contato-tipo-api.service";
import { ContatoTipoService } from "./contato-tipos/shared/contato.service";
import { ContatoFormComponent } from "./contato-form/contato-form.component";

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    ContatoTipoApiService,
    ContatoTipoService
  ],
  declarations: [
    ContatoFormComponent
  ],
  exports: [
    ContatoFormComponent
  ]
})
export class ContatosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/contatos/contatos.module.ts
 **/